// ============================================================
// PLUMME 3 — Kjørebok · GPS-sporing
// Regelen som avgjør hva ett GPS-punkt betyr for strekningen. Den ligger her og ikke
// i siden fordi det er denne regelen som bestemmer kilometeren i kjøreboken, og et
// fradrag skal hvile på noe som kan testes.
//
// GPS-en leverer punkter også når bilen står stille. Uten terskler blir ren måle-
// jitter lagt til som kjørte meter, og kjøreboken skal dokumentere faktisk kjørt
// strekning — ikke støy.
// ============================================================
(function mileageGps(global) {
  // Dårligere usikkerhet enn dette sier ingenting om strekning: tunnel, parkeringshus
  // eller tett by. Punktet forkastes, men ankerpunktet står igjen, så strekningen måles
  // fra forrige gode punkt i stedet for å gå tapt.
  const MAX_ACCURACY_M = 35;
  // Kortere sprang fra ankeret regnes som støy. Ankeret beholdes når spranget er under
  // terskelen — da samler ikke jitter seg opp mens bilen står stille, samtidig som
  // kjøring i lav fart summeres riktig så snart bilen faktisk har flyttet seg langt nok.
  const MIN_STEP_M = 20;
  // Nettleseren struper watchPosition når skjermen låses. Neste punkt ligger da langt
  // unna, og det er ekte kjøring vi ikke har målt. Strekningen holdes utenfor summen,
  // men skal meldes fra om — et hull betyr at kilometeren er for lav.
  const GAP_KM = 5;

  const EARTH_RADIUS_KM = 6371;
  const toRad = (value) => value * Math.PI / 180;

  const distanceKm = (from, to) => {
    if (!from || !to) return 0;
    const latDiff = toRad(to.latitude - from.latitude);
    const lonDiff = toRad(to.longitude - from.longitude);
    const lat1 = toRad(from.latitude);
    const lat2 = toRad(to.latitude);
    const a = Math.sin(latDiff / 2) ** 2 + Math.sin(lonDiff / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
    return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // Returnerer hva punktet skal føre til:
  //   ignore — forkast punktet, behold ankeret
  //   anchor — første gode punkt, sett ankeret uten å telle strekning
  //   gap    — ekte kjøring vi ikke har målt; teller ikke, men skal varsles
  //   count  — legg km til strekningen og flytt ankeret
  const step = (anchor, next, accuracy) => {
    const acc = Number(accuracy);
    if (Number.isFinite(acc) && acc > MAX_ACCURACY_M) return { action: 'ignore', km: 0 };
    if (!next || !Number.isFinite(Number(next.latitude)) || !Number.isFinite(Number(next.longitude))) {
      return { action: 'ignore', km: 0 };
    }
    if (!anchor) return { action: 'anchor', km: 0 };
    const km = distanceKm(anchor, next);
    if (!Number.isFinite(km) || km <= 0) return { action: 'ignore', km: 0 };
    if (km > GAP_KM) return { action: 'gap', km };
    if (km * 1000 < MIN_STEP_M) return { action: 'ignore', km: 0 };
    return { action: 'count', km };
  };

  global.PlummeMileageGps = {
    MAX_ACCURACY_M,
    MIN_STEP_M,
    GAP_KM,
    distanceKm,
    step,
  };
}(window));
